import { useCallback, useState } from 'react';

/**
 * Simple hook that propagates async errors to a parent ErrorBoundary. This is useful for handling errors in async functions outside of the React lifecycle.
 * @returns A function that throws an error. Call this function to throw an error that will be caught by the nearest ErrorBoundary.
 */
export const useThrowAsyncError = () => {
    const [, setState] = useState();

    const throwError = useCallback((error: Error) => {
        setState(() => {
            throw error;
        });
    }, []);

    return throwError;
};
